import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { TemplatesService } from '@core/services/templates.service';
import { Constants } from '@shared/class/constants.class';
import { Template, TypeTemplate } from '@shared/interfaces/template';

@Component({
  selector: 'app-templates-edit',
  templateUrl: './templates-edit.component.html'
})
export class TemplatesEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public template: Template;
  public templatesList: Array<Template> = [];
  public templateForm: FormGroup;
  public typesList: Array<TypeTemplate> = [
    { id: '1', name: 'Test' },
    { id: '3', name: 'Test' },
    { id: '2', name: 'Test' }
  ];
  public type: string;

  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private templatesService: TemplatesService,
    public dialogRef: MatDialogRef<TemplatesEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.constants.title = this.appConfig.LANG.templates.title;

    this.templateForm = new FormGroup({
      id: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      value: new FormControl('', Validators.required),
      idType: new FormControl('', Validators.required)
    });

    this.constants.action = this.data.action;

    if (this.constants.action === this.appConfig.ACTIONS.edit.id) {
      this.constants.title =
        this.appConfig.LANG.title.edit + ' ' + this.constants.title;
      this.template = this.data.item;
      this.templateForm.patchValue({
        id: this.template.id,
        name: this.template.name,
        value: this.template.value,
        idType: this.template.idType
      });
      this.type = this.template.type;
    } else if (this.constants.action === this.appConfig.ACTIONS.add.id) {
      if (this.typesList.length <= 0) {
        this.constants.admitted = false;
      } else {
        this.constants.title =
          this.appConfig.LANG.title.add + ' ' + this.constants.title;
      }
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.templateForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.constants.action,
        form,
        this.dialogRef,
        this.templatesService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }

  setType() {
    this.type = this.templateForm.value.idType;
  }
}
